import React from 'react';
import { Platform } from 'react-native';
import { usePWAInstall } from '../../hooks/use-pwa-install';
import { PWAInstallBanner } from './pwa-install-banner';
import { PWAInstallModal } from './pwa-install-modal';

export function PWAInstallPrompt() {
  // Only render on web platform
  if (Platform.OS !== 'web') {
    return null;
  }

  const {
    showBanner,
    showModal,
    isIOS,
    dismissBanner,
    dismissModal,
    showInstallModal,
    handleInstall,
    dontShowAgain,
  } = usePWAInstall();

  return (
    <>
      {showBanner && (
        <PWAInstallBanner
          onInstallPress={showInstallModal}
          onDismiss={dismissBanner}
        />
      )}
      
      <PWAInstallModal
        visible={showModal}
        isIOS={isIOS}
        onInstall={handleInstall}
        onDismiss={dismissModal}
        onDontShowAgain={dontShowAgain}
      />
    </>
  );
}